module.exports = __webpack_public_path__ + "static/media/downArrow.6c37634e.svg";